import { TypeIdSchema, application } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';
import { PublicOrganizationSchema } from '../organization/organization.schema';

export const ApplicationSchema = createSelectSchema(application);

export const InsertApplicationSchema = createInsertSchema(application);

export const PublicApplicationSchema = Type.Composite([
  Type.Omit(ApplicationSchema, ['id', 'public_id', 'organization_id']),
  Type.Object({
    object: Type.Literal('Application'),
    id: TypeIdSchema('app'),
    organization_id: TypeIdSchema('organization'),
    hosted_auth_domains: Type.Array(Type.String()),
  }),
]);

export const PublicApplicationWithSettingsSchema = Type.Composite([
  PublicApplicationSchema,
  Type.Object({
    settings: Type.Array(Type.Object({ key: Type.String(), value: Type.String() })),
    organization: PublicOrganizationSchema,
  }),
]);

export type Application = typeof application.$inferSelect;
export type InsertApplication = typeof application.$inferInsert;
export type PublicApplication = Static<typeof PublicApplicationSchema>;
export type PublicApplicationWithSettings = Static<typeof PublicApplicationWithSettingsSchema>;
